/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useRef, useEffect } from 'react';
import DEFAULT_AUDIO from '../assets/ding.mp3';

const useAudioRef = (audio = DEFAULT_AUDIO) => {
    const audioRef = useRef(null);

    useEffect(() => {
        audioRef.current = new Audio(audio);
    }, []);

    return audioRef;
};

export default useAudioRef;
